<script>
    import SmartTable from "Components/SmartTable";
    export default {
        extends: SmartTable,
        data: () => ({
            title: 'Configurare puncte de lucru',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Denumire', value: 'name' },
                { text: 'CUI', value: 'vat_no', sortable: false },
                { text: 'Sediu', value: 'full_address', sortable: false },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                this.loading = true
                let { data, meta } = await this.$db.Workstation
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                    .get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            editItem (item) {
                this.$router.push({ name: 'admin-configuration-edit', params: { id: item.id } })
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.Workstation) {
                    await item.delete()
                } else {
                    console.warn('Here comes the headache...')
                    console.log('model', this.$db.Supplier)
                    console.log(item, this.editedIndex, item instanceof this.$db.Supplier)
                    const model = await this.$db.Supplier.find(item.id)
                    console.log(model, model.id)
                    await model.delete()
                }
                this.dialogDelete = false
                await this.initialize()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
            },

            addNewItem: function() {
                this.$router.push({ name: 'admin-configuration-create' })
            },
        },
    };
</script>
